module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"allKPIs":"All KPIs"},"de":{"allKPIs":"Alle KPIs"}}')
  delete Component.options._Ctor
}
